import React from "react";
import "./contact.css";
import tiktokIcon from "../../media/images/tiktokIcon.png";
import instagramIcon from "../../media/images/instagramIcon.png";
import callIcon from "../../media/images/callIcon.png";
import whatsappIcon from "../../media/images/whatsappIcon.png";

const Contact = () => {
    return (
        <div id="contact">
            <h1 className="head">אז מה אתם מחכים, צרו&nbsp;איתנו&nbsp;קשר</h1>
            <ul>
                <li>
                    <div className="socials">
                        <a
                            href="https://www.tiktok.com/@batim.v.ganim?_t=8kaulOtu71z&_r=1&fbclid=PAZXh0bgNhZW0CMTEAAafL2aNBLTI3AgWGpwYnxQSWGDbSG7iZF-dLqr1V-4DmEgWNPj20WwpnCQES0w_aem_j-Wwqw-5CaoJ1yFCHIpSuQ"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={tiktokIcon} alt="Tiktok icon" />
                        </a>
                        <a
                            href="https://www.instagram.com/dudi_house_garden?utm_source=qr&igsh=MWlqYWx5am9vMXp2Mw%3D%3D"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={instagramIcon} alt="Instagram icon" />
                        </a>
                        <a href="tel:0544361266">
                            <img src={callIcon} alt="Call icon" />
                        </a>
                        <a
                            href="https://wa.me/972544361266"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={whatsappIcon} alt="Whatsapp icon" />
                        </a>
                    </div>
                </li>
                <li>054-436-1266</li>
            </ul>
        </div>
    );
};

export default Contact;
